import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const FeaturesSection = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <section id="features" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl p-8 text-white hover:scale-105 transition-transform cursor-pointer">
            <h3 className="text-2xl font-bold mb-2">{t('common:features.pdfToDoc')}</h3>
            <p className="text-gray-300 text-sm mb-6">{t('common:features.pdfToDocDesc')}</p>
            <div className="mb-6">
              <img
                src="https://public.readdy.ai/ai/img_res/c6c670ff6909e670a82267b8f92592dd.jpg"
                alt="PDF to Documents"
                className="w-full h-48 object-cover rounded-lg"
              />
            </div>
            <button
              onClick={() => navigate('/pdf-to-word')}
              className="w-full px-6 py-3 bg-white text-gray-900 rounded-full font-medium hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              {t('common:features.startConvert')}
            </button>
          </div>

          <div className="bg-gradient-to-br from-amber-50 to-white rounded-2xl p-8 border border-gray-200 hover:scale-105 transition-transform cursor-pointer">
            <div className="inline-flex items-center gap-2 px-3 py-1 bg-teal-100 text-teal-700 rounded-full text-xs font-medium mb-4">
              <i className="ri-star-fill"></i>
              <span>{t('common:features.mostPopular')}</span>
            </div>
            <div className="mb-6">
              <img
                src="https://readdy.ai/api/search-image?query=modern%20minimalist%20illustration%20of%20multiple%20JPG%20PNG%20images%20being%20converted%20into%20single%20PDF%20document%20with%20clean%20simple%20background%20showing%20image%20thumbnails%20and%20PDF%20icon%20in%20professional%20style%20with%20consistent%20light%20neutral%20backdrop&width=400&height=300&seq=feat2&orientation=landscape"
                alt="Image to PDF"
                className="w-full h-48 object-cover rounded-lg"
              />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2">{t('common:features.imageToPdf')}</h3>
            <p className="text-gray-600 text-sm mb-6">{t('common:features.imageToPdfDesc')}</p>
            <button
              onClick={() => navigate('/image-convert')}
              className="w-full px-6 py-3 bg-gray-900 text-white rounded-full font-medium hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer"
            >
              {t('common:features.useNow')}
            </button>
          </div>

          <div className="bg-gradient-to-br from-teal-50 to-white rounded-2xl p-8 border border-gray-200 hover:scale-105 transition-transform cursor-pointer">
            <div className="mb-6">
              <img
                src="https://readdy.ai/api/search-image?query=modern%20minimalist%20illustration%20showing%20PDF%20files%20being%20merged%20and%20split%20with%20clean%20simple%20background%20featuring%20multiple%20PDF%20documents%20combining%20and%20separating%20in%20professional%20style%20with%20consistent%20light%20neutral%20backdrop&width=400&height=300&seq=feat3&orientation=landscape"
                alt="PDF Merge Split"
                className="w-full h-48 object-cover rounded-lg"
              />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2">{t('common:features.pdfMerge')}</h3>
            <p className="text-gray-600 text-sm mb-6">{t('common:features.pdfMergeDesc')}</p>
            <button
              onClick={() => navigate('/pdf-tools')}
              className="w-full px-6 py-3 bg-gray-900 text-white rounded-full font-medium hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer"
            >
              {t('common:features.useNow')}
            </button>
          </div>
        </div>

        <div className="flex justify-center mb-16">
          <div className="bg-gray-50 rounded-lg w-full max-w-md h-64 flex items-center justify-center border border-gray-200">
            <p className="text-gray-400 text-sm">{t('home:ads.middleBanner')} 300×250</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
